module.exports = __webpack_public_path__ + "img/10.53a1552f.jpg";